module.exports = __webpack_public_path__ + "img/manufacturing.3df80676.svg";